module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_4.e4a1f1cd.png";